// fetch client deposits
export const FETCH_STRATEGY_REQUESTED = "FETCH_STRATEGY_REQUESTED";
export const FETCH_STRATEGY_SUCCESS = "FETCH_STRATEGY_SUCCESS";
export const FETCH_STRATEGY_FAIL = "FETCH_STRATEGY_FAIL";
